// @flow
import type { CohortPassenger } from 'types/entities';
import type { Errors } from 'types/errors';

import React, { Component, PropTypes } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { libraryPassengerAdd } from 'actions/library';

import PassengerForm from 'components/entities/PassengerForm';
import ErrorsNotification from 'components/others/ErrorNotification';

type Props = {
  libraryPassengerAdd: Function,
};

export class PassengerAddPage extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      showFormError: false,
      errors: [],
    };
  }

  state: {
    showFormError: boolean,
    errors: Errors,
  };
  form: Object;
  props: Props;

  hideErrors() {
    this.setState({
      showFormError: false,
      errors: [],
    });
  }

  render() {
    return (
      <DocumentTitle title="Add Passenger">
        <div className="section">
          <div className="container">
            <div className="columns">
              <div className="column is-half is-offset-one-quarter">
                <h1 className="title">
                  Add Library Passenger
                </h1>
                <hr />
                <PassengerForm ref={(input) => { this.form = input; }} />
                <hr />
                {this.state.showFormError &&
                  <ErrorsNotification
                    errors={this.state.errors}
                    dismissible
                    onClose={() => this.hideErrors()}
                  />
                }
                <div className="field is-grouped is-pulled-right">
                  <p className="control">
                    <Link
                      to="/library"
                      className="button is-outlined"
                      title="Back to library"
                      aria-label="Back to library"
                    >
                      Back
                    </Link>
                  </p>
                  <p className="control">
                    <button
                      className="button is-primary"
                      onClick={() => {
                        if (!this.form.isValid()) {
                          this.setState({
                            showFormError: true,
                            errors: this.form.errors(),
                          });
                          return;
                        }
                        const passenger: CohortPassenger = this.form.getValue();
                        this.props.libraryPassengerAdd(passenger);
                        this.context.router.push('/library');
                      }}
                    >
                      Add
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

PassengerAddPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

function mapStateToProps() {
  return {};
}

export default connect(
  mapStateToProps,
  {
    libraryPassengerAdd,
  }
)(PassengerAddPage);



/** WEBPACK FOOTER **
 ** ./src/js/views/library/passengers/PassengerAddPage.jsx
 **/